import React from 'react';
import './Pages.css';

function About() {
  return (
    <div className="container">
      <div className="page-content">
        <h1>About Us</h1>

        <div className="page-section">
          <p>
            Stickyours.com is an easy-to-use online platform designed to help individuals, creators,
            and small businesses create custom stickers quickly and effortlessly.
          </p>

          <p>
            We built Stickyours with one clear goal: to simplify sticker creation without the need
            for professional design skills or expensive software. Our tools are made for beginners
            and professionals alike, allowing anyone to turn ideas, artwork, or images into
            high-quality stickers in just a few steps.
          </p>
        </div>

        <div className="page-section">
          <h2>What We Do</h2>
          <p>
            Stickyours provides simple and powerful tools to design, customize, and prepare stickers
            for personal use, digital projects, or printing. From clean cut-outs to creative
            customization options, our platform helps you achieve professional results with minimal effort.
          </p>

          <p>
            Whether you're creating stickers for branding, social media, online shops, planners, or
            personal projects, Stickyours gives you full creative control in a fast and reliable way.
          </p>
        </div>

        <div className="page-section">
          <h2>Why Stickyours?</h2>
          <ul>
            <li><strong>Easy Sticker Maker Online</strong> – Create custom stickers in minutes</li>
            <li><strong>Beginner-Friendly Platform</strong> – No design experience required</li>
            <li><strong>Creative Customization</strong> – Adjust shapes, styles, and details</li>
            <li><strong>Fast Results</strong> – Instant previews and smooth workflow</li>
            <li><strong>Creator-Focused</strong> – Built for artists, businesses, and everyday users</li>
          </ul>
        </div>

        <div className="page-section">
          <h2>Who Stickyours Is For</h2>
          <p>Stickyours is perfect for:</p>
          <ul>
            <li>Small business owners and brands</li>
            <li>Content creators and social media marketers</li>
            <li>Artists and designers</li>
            <li>Students, hobbyists, and sticker lovers</li>
          </ul>
        </div>

        <div className="page-section">
          <p>
            Our mission is to make custom sticker creation simple, accessible, and enjoyable for everyone.
          </p>
          <p className="highlight">
            At Stickyours.com, your creativity comes first—and we're here to help your ideas stick.
          </p>
        </div>

        <div className="page-section contact-info">
          <h2>Contact Us</h2>
          <p>Email: <a href="mailto:dmstickyours@gmail.com">dmstickyours@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
}

export default About;
